import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-phone-input-2/lib/bootstrap.css";
import PhoneInput from "react-phone-input-2";
import { FiEye, FiEyeOff } from "react-icons/fi";
import "./Loginsignup.css";
import rekonicLogo from "../../assests/rekonic.svg";

const API_BASE = "https://45.76.62.40";

const LoginSignup = () => {
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    companyName: "",
    username: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ---------------- LOGIN ----------------
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: formData.username.toLowerCase(),
          password: formData.password,
        }),
      });
      const data = await res.json();
      if (res.ok && data.access_token) {
        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("user_id", data.user_id);
        localStorage.setItem("username", data.username);
        window.location.href = "/dashboard";
      } else {
        alert(data.detail || "Login failed");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }
  };

  // ---------------- REGISTER ----------------
  const handleRegister = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    try {
      const res = await fetch(`${API_BASE}/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          first_name: formData.firstName,
          last_name: formData.lastName,
          phone_number: "+" + formData.phoneNumber,
          email: formData.email,
          company: formData.companyName,
          password: formData.password,
          confirm_password: formData.confirmPassword,
          username: formData.username.toLowerCase(),
        }),
      });
      const data = await res.json();
      if (res.ok) {
        alert("Registration successful! Please log in.");
        setIsLogin(true);
        setFormData({
          firstName: "",
          lastName: "",
          phoneNumber: "",
          email: "",
          companyName: "",
          username: "",
          password: "",
          confirmPassword: "",
        });
      } else {
        alert(data.detail || "Registration failed");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }
  };

  return (
    <div className="auth-page">
      {/* ──── Left Branding Panel ──── */}
      <div className="auth-left">
        <div className="auth-logo-wrapper">
          <img src={rekonicLogo} alt="Rekonic" className="auth-logo-img" />
          <div className="auth-divider" />
          <p className="auth-tagline">Business, Your Way</p>
          <ul className="auth-feature-list">
            <li><span className="dot" />Smart Sales Management</li>
            <li><span className="dot" />Customer &amp; Supplier Tracking</li>
            <li><span className="dot" />Real-time Financial Insights</li>
            <li><span className="dot" />Invoicing &amp; Payments</li>
          </ul>
        </div>
      </div>

      {/* ──── Right Form Panel ──── */}
      <div className="auth-right">
        <div className="auth-card">
          <h1 className="auth-card-title">
            {isLogin ? "Welcome back" : "Create account"}
          </h1>
          <p className="auth-card-subtitle">
            {isLogin
              ? "Sign in to your Rekonic dashboard"
              : "Get started — it's free"}
          </p>

          {/* ── LOGIN FORM ── */}
          {isLogin ? (
            <form onSubmit={handleLogin} autoComplete="off">
              <div className="auth-field">
                <label htmlFor="login-username">Username</label>
                <input
                  id="login-username"
                  type="text"
                  name="username"
                  placeholder="Enter your username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="auth-field">
                <label htmlFor="login-password">Password</label>
                <input
                  id="login-password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <span
                  className="eye-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </span>
              </div>

              <button type="submit" className="auth-btn">
                Sign In
              </button>
            </form>
          ) : (
            /* ── REGISTER FORM ── */
            <form onSubmit={handleRegister} autoComplete="off">
              <div className="auth-row">
                <div className="auth-field">
                  <label>First Name</label>
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="auth-field">
                  <label>Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="auth-field">
                <label>Phone Number</label>
                <PhoneInput
                  country={"pk"}
                  enableSearch={true}
                  value={formData.phoneNumber}
                  onChange={(phone) =>
                    setFormData({ ...formData, phoneNumber: phone })
                  }
                />
              </div>

              <div className="auth-field">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="auth-field">
                <label>Company (optional)</label>
                <input
                  type="text"
                  name="companyName"
                  placeholder="Your company name"
                  value={formData.companyName}
                  onChange={handleChange}
                />
              </div>

              <div className="auth-field">
                <label>Username</label>
                <input
                  type="text"
                  name="username"
                  placeholder="Choose a username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="auth-row">
                <div className="auth-field">
                  <label>Password</label>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                  <span
                    className="eye-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </span>
                </div>
                <div className="auth-field">
                  <label>Confirm Password</label>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Repeat"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                  />
                  <span
                    className="eye-toggle"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                  </span>
                </div>
              </div>

              <button type="submit" className="auth-btn">
                Create Account
              </button>
            </form>
          )}

          <p className="auth-toggle">
            {isLogin ? "Don't have an account? " : "Already have an account? "}
            <span onClick={() => setIsLogin(!isLogin)}>
              {isLogin ? "Register" : "Login"}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};
export default LoginSignup;
